import actionList from '@/libs/acl_roles/actionList'

const { ACTION_VIEW, ACTION_UPDATE } = actionList

export default [
  // *===============================================---*
  // *--------- User management pages ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/user-management/list',
    name: 'user-list',
    component: () => import('@/views/apps/user-list/Index.vue'),
    meta: {
      resource: 'users',
      action: ACTION_VIEW,
      pageTitle: 'Users',
      breadcrumb: [
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-management/update/:id',
    name: 'user-management-update',
    component: () => import('@/views/apps/user-list/Update.vue'),
    meta: {
      resource: 'users',
      action: ACTION_UPDATE,
      navActiveLink: 'user-list',
      pageTitle: 'Update User',
      breadcrumb: [
        {
          text: 'List',
          to: '/user-management/list',
        },
        {
          text: 'Update',
          active: true,
        },
      ],
    },
  },
]
